import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, CheckCircle } from "@phosphor-icons/react";

const BENEFITS = [
  "Detrazione IRPEF fino al 50% sull'acquisto di nuovi infissi",
  "Ecobonus per interventi di riqualificazione energetica",
  "Conto Termico per impianti a fonte rinnovabile",
  "Bonus Casa per opere di ristrutturazione",
  "Finanziamenti agevolati con rate pluriennali",
  "Pratiche fiscali gestite completamente da noi",
];

export default function DetrazioniPage() {
  return (
    <div data-testid="detrazioni-page" className="pt-[140px] pb-20">
      <div className="max-w-[1480px] mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-6">Bonus fiscali · Aggiornato 2025</div>
            <h1 className="font-display text-[clamp(2.8rem,8vw,7rem)] leading-[0.88] tracking-tighter font-medium">
              Risparmia <span className="text-[#EB0D0D]">50%</span> sulla<br />tua casa.
            </h1>
          </div>
          <div className="lg:col-span-5">
            <p className="text-lg text-[#5C5A55] leading-relaxed">
              Sostituire infissi, installare pergole o un impianto fotovoltaico ti permette di accedere a importanti detrazioni fiscali. Noi ci occupiamo di tutta la documentazione necessaria.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-20">
          {BENEFITS.map((b, i) => (
            <div key={i} data-testid={`benefit-${i}`} className="flex items-start gap-4 bg-[#F0EFEB] p-6 border border-[#D1CFC7]/40">
              <CheckCircle size={28} weight="duotone" className="text-[#EB0D0D] flex-shrink-0" />
              <span className="text-base text-[#1A1918] leading-relaxed">{b}</span>
            </div>
          ))}
        </div>

        <div className="mt-24 bg-[#1A1918] text-[#FAF9F6] p-10 md:p-16 lg:p-20 relative overflow-hidden">
          <div className="absolute top-0 right-0 font-display text-[20rem] leading-none opacity-10 -mt-8 select-none">50%</div>
          <div className="relative grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <div className="text-xs uppercase tracking-[0.25em] text-[#EB0D0D] mb-4">Pratiche gestite</div>
              <h2 className="font-display text-4xl md:text-5xl tracking-tighter leading-[0.95] font-medium">
                Burocrazia<br />zero stress.
              </h2>
              <p className="mt-6 text-[#FAF9F6]/70 leading-relaxed">
                Il nostro ufficio tecnico gestisce comunicazioni ENEA, asseverazioni, fatturazione conforme alla cessione del credito e tutta la documentazione fiscale.
              </p>
            </div>
            <div className="flex flex-wrap gap-4 md:justify-end">
              <Link to="/contatti" data-testid="detrazioni-cta" className="inline-flex items-center gap-3 bg-[#EB0D0D] hover:bg-[#C00A0A] text-[#FAF9F6] px-7 py-4 text-sm uppercase tracking-[0.15em] font-bold rounded-sm transition-all">
                Richiedi info <ArrowUpRight size={16} weight="bold" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
